module.exports = "/static/assets/ab7968f239275b438d7f98891394c2ec.png";